import React, { useEffect, useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import styled from "styled-components";
import checkCircle from "../../assets/images/check_circle.svg";
import checkCircleOff from "../../assets/images/check_circle-off.svg";

function SignModalContent(props: {
  type: 1 | 2;
  groupName?: string;
  setSignBase64: React.Dispatch<React.SetStateAction<string | null>>;
  name: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  setModalState?: React.Dispatch<React.SetStateAction<boolean>>;
  rejectConfirmCondition?: boolean;
  rejectConfirmMsg?: string;
}) {
  const [agreeChecked, setAgreeChecked] = useState(false);
  const [hasStartedSigning, setHasStartedSigning] = useState(false);
  useEffect(() => {
    props.setSignBase64(null);
  }, []);

  const ref = useRef<SignatureCanvas>(null);

  const handleRefresh = () => {
    props.setSignBase64(null);
    ref.current?.clear();
    setHasStartedSigning(false);
  };

  const handleCancel = () => {
    props.onCancel && props.onCancel();
    props.setModalState && props.setModalState(false);
  };

  const handleConfirm = () => {
    if (props.rejectConfirmCondition) {
      alert(props.rejectConfirmMsg || "먼저 서명을 진행하세요.");
      return;
    }
    if (!agreeChecked) {
      return;
    }
    props.onConfirm && props.onConfirm();
    props.setModalState && props.setModalState(false);
  };

  return (
    <SignatureModalContainer>
      <SignatureModal>
        <SignatureModalContent>
          <SignatureFormSection>
            <SignatureTitleContainer>
              <SignatureTitle> {props.type === 1 ? "신청인 서명" : "협약서 서명"}</SignatureTitle>
              {/* {props.type === 2 && (
                <RegulationButton
                  onClick={() => {
                    // 취소/위약 규정 팝업 로직 추가 필요
                    alert("취소/위약 규정을 확인해주세요.");
                  }}
                >
                  취소/위약 규정
                </RegulationButton>
              )} */}
            </SignatureTitleContainer>
            <SignatureForm>
              <SignatureFormContent>
                {/* 동의 체크박스 - 서명 아래로 이동 */}
                <AgreementSection>
                  <div
                    className="check-icon"
                    onClick={() => setAgreeChecked((prev) => !prev)}
                    role="button"
                    aria-pressed={agreeChecked}
                  >
                    {agreeChecked ? (
                      <img src={checkCircle} alt="check-circle" />
                    ) : (
                      <img src={checkCircleOff} alt="check-circle-off" />
                    )}
                  </div>
                  <AgreementText>예약 및 취소 규정을 확인했습니다.</AgreementText>
                </AgreementSection>
                <ApplicantInfo>
                  티샷은 연단체 예약에 대한 통신판매중개자이며, 에약과 취소거래에 대한 책임을 지지
                  않습니다.
                </ApplicantInfo>
                {/* 이용 수수료 안내 메모칸 */}
                <FeeNoticeSection>
                  <FeeNoticeTitle>이용 수수료 안내</FeeNoticeTitle>
                  <FeeNoticeContent>
                    연단체 서비스 이용시 매월 라운드마다 팀당 1만원의 부킹 수수료가 발생합니다. 본
                    수수료는 서비스 운영 및 골프장 협력 비용 개선에 사용됩니다.
                    <br />
                  </FeeNoticeContent>
                </FeeNoticeSection>

                <SignatureAreaContainer>
                  <SignatureArea>
                    <SignatureCanvas
                      penColor="black"
                      backgroundColor="transparent"
                      ref={ref}
                      canvasProps={{
                        width: 250,
                        height: 150,
                        className: "sigCanvas",
                      }}
                      onBegin={() => {
                        setHasStartedSigning(true);
                      }}
                      onEnd={(e) => {
                        const dd = ref?.current?.toDataURL();
                        props.setSignBase64(dd as string);
                      }}
                    />
                  </SignatureArea>
                  {!hasStartedSigning && (
                    <SignatureAreaText>
                      <ApplicantInfo3>
                        <SignatureIcon>
                          <span className="material-symbols-outlined">stylus_fountain_pen</span>
                        </SignatureIcon>
                        상기 협약에 동의하고 서명합니다.
                      </ApplicantInfo3>
                      <ApplicantInfo2>신청인: {props.name}</ApplicantInfo2>
                    </SignatureAreaText>
                  )}
                </SignatureAreaContainer>
              </SignatureFormContent>
              <SignatureFormActions>
                <ErrorMessage>예약 및 취소 규정을 동의해주세요.</ErrorMessage>
                <RefreshButton onClick={handleRefresh}>
                  <RefreshIcon>
                    <svg
                      width="10"
                      height="10"
                      viewBox="0 0 10 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5 9.66658C3.69722 9.66658 2.59375 9.2145 1.68958 8.31034C0.785417 7.40617 0.333334 6.3027 0.333334 4.99992C0.333334 3.69714 0.785417 2.59367 1.68958 1.6895C2.59375 0.785335 3.69722 0.333252 5 0.333252C5.67083 0.333252 6.3125 0.471794 6.925 0.748877C7.5375 1.02596 8.0625 1.42214 8.5 1.93742V0.333252H9.66667V4.41658H5.58333V3.24992H8.03333C7.72222 2.70547 7.29688 2.2777 6.75729 1.96659C6.21771 1.65547 5.63195 1.49992 5 1.49992C4.02778 1.49992 3.20139 1.8402 2.52083 2.52075C1.84028 3.20131 1.5 4.0277 1.5 4.99992C1.5 5.97214 1.84028 6.79853 2.52083 7.47908C3.20139 8.15964 4.02778 8.49992 5 8.49992C5.74861 8.49992 6.42431 8.28603 7.02708 7.85825C7.62986 7.43047 8.05278 6.86659 8.29583 6.16658H9.52083C9.24861 7.19714 8.69444 8.03811 7.85833 8.6895C7.02222 9.34089 6.06945 9.66658 5 9.66658Z"
                        fill="#1A1A1A"
                      />
                    </svg>
                  </RefreshIcon>
                  <RefreshText>다시쓰기</RefreshText>
                </RefreshButton>
              </SignatureFormActions>
            </SignatureForm>
          </SignatureFormSection>
        </SignatureModalContent>
        <SignatureModalButtons>
          <SignatureCancelButton onClick={handleCancel}>취소</SignatureCancelButton>
          <SignatureConfirmButton
            onClick={handleConfirm}
            disabled={!agreeChecked || !hasStartedSigning}
          >
            서명하기
          </SignatureConfirmButton>
        </SignatureModalButtons>
      </SignatureModal>
    </SignatureModalContainer>
  );
}

export default SignModalContent;

const SignatureModalContainer = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100dvh;
  background-color: #00000092;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const SignatureModal = styled.div`
  width: 90%;
  max-width: 400px;
  background: #fdfdfd;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
`;

const SignatureModalContent = styled.div`
  padding: 24px;
`;

const SignatureFormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const SignatureTitleContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
`;

const SignatureTitle = styled.h1`
  color: #1a1a1a;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  margin: 0;
  text-align: center;
`;

const SignatureForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const SignatureFormContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const ApplicantInfo = styled.div`
  color: var(--Teeshot-Neutrals-Color-Teeshot-G1, #79818a);
  /* 14_Body/14M */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;
const ApplicantInfo2 = styled.div`
  color: var(--Teeshot-Neutrals-Color-Teeshot-G1, #79818a);
  /* 14_Body/14M */
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 10px; /* 128.571% */
`;
const ApplicantInfo3 = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
  color: var(--Teeshot-Neutrals-Color-Teeshot-G1, #79818a);
  /* 14_Body/14M */
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  white-space: nowrap;
`;

const SignatureIcon = styled.span`
  display: inline-flex;
  align-items: center;
  color: #79818a;
  font-size: 11px;

  .material-symbols-outlined {
    font-size: 16px !important;
    color: #79818a; !important;
    font-variation-settings: "FILL" 1, "wght" 500, "GRAD" 0, "opsz" 17;
  }
`;
const SignatureArea = styled.div`
  width: 100%;
  height: 150px;
  background: #f0f0f4;
  border: 1px solid #d1d5d8;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  .sigCanvas {
    width: 100% !important;
    height: 100% !important;
  }
`;

const SignatureFormActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
`;

const ErrorMessage = styled.div`
  color: #f97000;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
`;

const RefreshButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: #f0f0f4;
  border: 1px solid #d1d5d8;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #e0e0e4;
  }
`;

const RefreshIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const RefreshText = styled.span`
  color: #1a1a1a;
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
`;

const SignatureModalButtons = styled.div`
  display: flex;
  border-top: 1px solid #d1d5d8;
`;

const SignatureCancelButton = styled.button`
  flex: 1;
  height: 60px;
  padding: 12px 0;
  background: #79818a;
  border: none;
  border-radius: 0;
  color: #fdfdfd;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #6a7279;
  }
`;

const SignatureConfirmButton = styled.button`
  flex: 1;
  height: 60px;
  padding: 12px 0;
  background: #004b49;
  border: none;
  border-radius: 0;
  color: #fdfdfd;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #003937;
  }

  &:disabled {
    background: #d1d5d8;
    cursor: not-allowed;
  }
`;

const FeeNoticeSection = styled.div`
  padding: 12px;
  background: #f0f0f4;
  border-radius: 6px;
  margin: 8px 0;
`;

const FeeNoticeTitle = styled.div`
  color: #79818a;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  margin-bottom: 8px;
`;

const FeeNoticeContent = styled.div`
  color: #79818a;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`;

const AgreementSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 16px;

  .check-icon {
    width: 24px;
    height: 24px;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
    }
  }
`;

const AgreementText = styled.div`
  color: #1a1a1a;
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  flex: 1;
`;

const SignatureAreaContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  position: relative;
`;

const SignatureAreaText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 1;
`;

const RegulationButton = styled.button`
  position: absolute;
  right: 0;
  min-width: 71px;
  display: flex;
  padding: 4px 6px;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  border: 0.5px solid #79818a;
  background: #fdfdfd;
  height: 20px;
  color: #1a1a1a;
  font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
  font-size: 10px;
  font-weight: 600;
  line-height: 16px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #f8f8f8;
  }
`;
